module.exports = __webpack_public_path__ + "static/img/przybornik_wielkosc2.b92c0a8d.png";